module.exports = __webpack_public_path__ + "img/new_mp_loade.175b5839.gif";